declare global {
  interface Window {
    iframeContext?: {
      ref: any;
    };
  }
}

export const postMessageToParent = (message: any) => {
  window.parent.postMessage(message, '*');
};

export const updateIframeHeight = (elemRef?: any) => {
  const elm = elemRef?.base || window.iframeContext?.ref?.base;

  if (elm) {
    postMessageToParent({
      action: 'contentHeight',
      height: elm.offsetHeight,
      /** @deprecated, but kept it since our partners may still be using it */
      setHeight: elm.offsetHeight,
    });
  }
};

export default updateIframeHeight;
